import { Children, cloneElement, isValidElement, memo, useContext } from 'react';
import type { MemoExoticComponent, PropsWithChildren, ReactNode } from 'react';

import { LightNodeRendererContext } from './LightRootRenderer.tsx';

export const LightNodeRenderer: MemoExoticComponent<
	({ children, renderIndex, ...props }: LightNodeRendererProps) => ReactNode
> = memo(({ children, renderIndex, ...props }: LightNodeRendererProps): ReactNode => {
	const shouldRenderNode = useContext(LightNodeRendererContext);
	const shouldRender = shouldRenderNode?.(renderIndex) ?? true;

	if (!shouldRender) {
		return null;
	}

	// Some node components add props to their children, outside of `serializeFragment`. Pass such props through:
	if (Object.keys(props).length) {
		return Children.map(children, (child) =>
			isValidElement(child) ? cloneElement(child, props) : child,
		);
	}

	return children;
});
LightNodeRenderer.displayName = 'LightNodeRenderer';

type LightNodeRendererProps = PropsWithChildren<{
	renderIndex: number;
}>;
